<div class="mainContainer">
  <div class="imgContainer">
    <img class="moduleImg" [src]="getModuleImg()" draggable="false" />
  </div>
  <div class="infoContainer" [ngStyle]="getTextColor()">
    <div class="infoBlock">
      <div class="title">
        {{ 'modules.static.whatDoesItMean' | translate }}
      </div>
      <div class="content">{{ module?.intro ?? '' }}</div>
      @if (canPlay) {
        <div (click)="startPlaying()" class="button ctaBtn" [ngStyle]="getButtonBgColor()">
          {{ 'modules.static.playButton' | translate }}
        </div>
      }
    </div>
  </div>
</div>
